import styled, { css, keyframes } from 'styled-components'
import TextInput from 'components/UI/TextInput'

const enter = keyframes`
  0% {
    max-width: 3.25rem;
  }

  100% {
    max-width: 100%;
  }
`

const show = keyframes`
0% {
  opacity: 0;
}

100% {
  opacity: 1;
}
`

const enterSearchBox = css`
  ${enter} 5s ease-out
`

const animationSearchClear = css`
  ${show} 1s ease-in-out
`

export const SearchBox = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${props => (props.isOpen ? '22.5rem' : '3.25rem')};
  padding: ${props => (props.isOpen ? '0 0.625rem 0 0.875rem' : '0.875rem')};
  padding-left: ${props => (props.isOpen ? '0.875rem' : '0.9375rem')};
  border-radius: 4px;
  border: ${props => (props.isOpen ? '1px solid #e3e7ed' : 'transparent')};
  background-color: ${props => (props.isOpen ? '#f7f9fc' : 'transparent')};
  transition: border-color 0.15s;

  input {
    // animation: ${props => (props.isOpen ? animationSearchClear : 'none')};
  }

  //animation: ${props => (props.isOpen ? enterSearchBox : 'none')};
  
  :focus-within {
    border: 1px solid #89919C;
  }
`

export const SearchBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div:first-of-type {
    margin: 0;
    width: 100%;
  }
`

export const SearchIconWrapper = styled.div`
  cursor: pointer;
  width: 22px;
  height: 22px;
`

// @ts-ignore
export const SearchInput = styled(TextInput)`
  border-style: none;
  font-weight: 600;
`

export const SearchClearWrapper = styled.div`
  width: 26px;
  height: 26px;
`

export const SearchClear = styled.button<{ isOpen: boolean }>`
  cursor: pointer;
  outline: 0;
  margin: 0;
  border-style: none;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  background-color: #e6eaf1;
  display: flex;
  justify-content: center;

  // animation: ${props => (props.isOpen ? animationSearchClear : 'none')};
`
